var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.10547V10.4388C13 11.3555 12.25 12.1055 11.3333 12.1055H2.16663V6.7888C2.77496 7.5138 3.70832 7.9638 4.74165 7.9388C5.58332 7.92214 6.34163 7.59714 6.90829 7.05547C7.16663 6.8388 7.38331 6.56379 7.54998 6.26379C7.84998 5.75546 8.01663 5.15545 7.99996 4.53045C7.97496 3.55545 7.54164 2.69714 6.86664 2.10547H13Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 12.1055V14.6055C18.8333 15.9888 17.7166 17.1055 16.3333 17.1055H15.5C15.5 16.1888 14.75 15.4388 13.8333 15.4388C12.9166 15.4388 12.1666 16.1888 12.1666 17.1055H8.83329C8.83329 16.1888 8.08329 15.4388 7.16663 15.4388C6.24996 15.4388 5.49996 16.1888 5.49996 17.1055H4.66663C3.28329 17.1055 2.16663 15.9888 2.16663 14.6055V12.1055H11.3333C12.25 12.1055 13 11.3555 13 10.4388V4.60547H14.5333C15.1333 4.60547 15.6833 4.93048 15.9833 5.44714L17.4083 7.9388H16.3333C15.875 7.9388 15.5 8.3138 15.5 8.77214V11.2721C15.5 11.7305 15.875 12.1055 16.3333 12.1055H18.8333Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 18.7708C8.08714 18.7708 8.83333 18.0246 8.83333 17.1042C8.83333 16.1837 8.08714 15.4375 7.16667 15.4375C6.24619 15.4375 5.5 16.1837 5.5 17.1042C5.5 18.0246 6.24619 18.7708 7.16667 18.7708Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 18.7708C14.7538 18.7708 15.5 18.0246 15.5 17.1042C15.5 16.1837 14.7538 15.4375 13.8333 15.4375C12.9128 15.4375 12.1666 16.1837 12.1666 17.1042C12.1666 18.0246 12.9128 18.7708 13.8333 18.7708Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 10.4375V12.1042H16.3333C15.875 12.1042 15.5 11.7292 15.5 11.2708V8.77083C15.5 8.3125 15.875 7.9375 16.3333 7.9375H17.4083L18.8333 10.4375Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 4.53238C8.01669 5.15738 7.85004 5.75739 7.55004 6.26572C7.38337 6.56572 7.16669 6.84073 6.90836 7.0574C6.34169 7.59907 5.58338 7.92406 4.74171 7.94073C3.70838 7.96573 2.77502 7.51573 2.16669 6.79073C2.05002 6.66573 1.95003 6.52407 1.85836 6.3824C1.53336 5.89074 1.35002 5.30742 1.33335 4.68242C1.30835 3.63242 1.77501 2.67406 2.52501 2.04906C3.09168 1.58239 3.80833 1.29073 4.59167 1.27406C5.46667 1.2574 6.2667 1.57406 6.8667 2.1074C7.5417 2.69906 7.97502 3.55738 8.00002 4.53238Z",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3667 4.62948L4.20837 5.42944L5.95001 3.74609",
    stroke: "#64247E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTick);
export default __webpack_public_path__ + "static/media/truck-tick.557004869cf2f7e8023091c6ec15ce9f.svg";
export { ForwardRef as ReactComponent };